module.exports = __webpack_public_path__ + "media/img/vca/categories/cafe-8e77713c32db1666827630ae36fbdf45.png";